<template>
<div class="chapter">
<div class="inner_page">
<div class="prologue" id="prologue1">
<p class="centerImage"><img alt="image" id="img13" src="images/img13.jpg"/></p>
<h2 class="caption">Vulcan flight deck as pictured in pilots’ notes.</h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// VulcanTestPilot_prologue1.vue?3e5588ee